import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components'
import { toggleSelected, toggleExpanded, selectAllNodesGraphed } from '../../store/positions/menuNodesSlice';
import { fetchStation} from '../../store/rules/ruleSchedulesSlice';
import { fetchPositions } from '../../store/positions/positionsSlice'
import { RecursiveNodes } from './RecursiveNodes';
import { useInterval } from '../../lib/hooks';

const StyledMenu = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  background: #FFF
  
  ::-webkit-scrollbar {
    display: none;
  }
  
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
`;

const Search = styled.div`
  width: 100%;
  height: 55px;
  background: #FFF;
  border-bottom: 1px solid #ddd;
`;

export const MultiselectPositionsMenu = ({ path }: { path?: string }) => {
  
  const menuNodes = useSelector(selectAllNodesGraphed);
  const dispatch = useDispatch();
  
  const onNodeClick = (node, e) => {
    console.log('meta key pressed - ' + e.metaKey);
    dispatch(toggleSelected({id: node.id, ctrlKey: e.ctrlKey || e.metaKey}));
    dispatch(fetchPositions(false));
    // dispatch(fetchStation());
  }

  const onNodeExpandClick = (node, e) => {
    dispatch(toggleExpanded({id: node.id}));
  }
  
  // useInterval(() => {
  //   dispatch(fetchPositions(false));
  // }, 60000)
  
  return (
    <StyledMenu>
      <Search/>
      <RecursiveNodes menuNodes={menuNodes} onNodeClick={onNodeClick} onNodeExpandClick={onNodeExpandClick}/>
    </StyledMenu>
  );
}
